module.exports = __webpack_public_path__ + "img/wow.029c3dc2.png";